import classNames from 'classnames';
import { Image } from '$components/basic/Image';
import Styled from './styled';

export interface IProps {
  readonly title: React.ReactNode;
  readonly imgAlt: string;
  readonly imgSource: string;
  readonly children: React.ReactNode;
  readonly className?: string;
}

function Tile({ title, children, imgAlt, imgSource, className, ...props }: IProps) {
  return (
    <Styled type={2} className={classNames('Tile', className)} {...props}>
      <Image provider="cloudinary" src={imgSource} alt={imgAlt} layout="fixed" width="56" height="64" />

      <div className="lower-div">
        <p className="title">{title}</p>
        <p className="content">{children}</p>
      </div>
    </Styled>
  );
}

Tile.displayName = 'Tile';
export default Tile;
